import React, { useState, useEffect } from 'react';
import { Calendar, Clock } from 'lucide-react';

export const DateTimeDisplay = ({ 
  showSeconds = true, 
  showIcon = true, 
  className = "", 
  format = "full" // "full", "date", "time", "compact"
}) => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      ...(showSeconds && { second: '2-digit' }),
      hour12: false
    };
    return date.toLocaleTimeString('es-ES', options);
  };

  const formatDate = (date) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return date.toLocaleDateString('es-ES', options);
  };

  const formatCompactDate = (date) => {
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const renderContent = () => {
    switch (format) {
      case 'date':
        return (
          <div className="flex items-center gap-2">
            {showIcon && <Calendar className="h-4 w-4 text-orange-500" />}
            <span className="text-sm sm:text-base font-medium">
              {formatDate(currentDateTime)}
            </span>
          </div>
        );
      
      case 'time':
        return (
          <div className="flex items-center gap-2">
            {showIcon && <Clock className="h-4 w-4 text-orange-500" />}
            <span className="text-lg sm:text-xl font-mono font-bold">
              {formatTime(currentDateTime)}
            </span>
          </div>
        );
      
      case 'compact':
        return (
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
            <div className="flex items-center gap-1">
              {showIcon && <Calendar className="h-3 w-3 text-orange-500" />}
              <span className="text-xs sm:text-sm">
                {formatCompactDate(currentDateTime)}
              </span>
            </div>
            <div className="flex items-center gap-1">
              {showIcon && <Clock className="h-3 w-3 text-orange-500" />}
              <span className="text-xs sm:text-sm font-mono">
                {formatTime(currentDateTime)}
              </span>
            </div>
          </div>
        );
      
      default: // 'full'
        return (
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              {showIcon && <Calendar className="h-4 w-4 text-orange-500" />}
              <span className="text-sm sm:text-base font-medium text-gray-700 capitalize">
                {formatDate(currentDateTime)}
              </span>
            </div>
            <div className="flex items-center gap-2">
              {showIcon && <Clock className="h-4 w-4 text-orange-500" />}
              <span className="text-lg sm:text-xl font-mono font-bold text-gray-900">
                {formatTime(currentDateTime)}
              </span>
            </div>
          </div>
        );
    }
  };

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4 ${className}`}>
      {renderContent()}
    </div>
  );
};